import {useHttp} from '../hooks/http.hook';

const usePortalService = () => {

    const {request, requestWithToken, requestImage, requestPdf, error, clearError} = useHttp();

    const getResource = async(url) => {
        return await requestWithToken(url, 'GET', null);
    }

    // Auth

    const login = async (credentials) => {
        const url = `auth/login`
        return await request(url, 'POST', JSON.stringify(credentials), {'Content-Type': 'application/json'}, 'include');
    }

    const loginWithCode = async (credentials) => {
        const url = `auth/loginWithCode`
        return await request(url, 'POST', JSON.stringify(credentials), {'Content-Type': 'application/json'}, 'include');
    }

    const registerManager = async(credentials) => {
        const url = `auth/registerManager`
        return await request(url, 'POST', JSON.stringify(credentials), {'Content-Type': 'application/json'}, 'include');
    }

    const registerStudent = async(credentials) => {
        const url = `auth/registerProfile`
        return await request(url, 'POST', JSON.stringify(credentials), {'Content-Type': 'application/json'}, 'include');
    }

    const resetPassword = async(data) => {
        const url = `auth/resetPassword`
        return await request(url, 'POST', JSON.stringify(data));
    }

    // Company

    const mainInformation = async () => {
        const url = `company/mainInformation`
        return await requestWithToken(url, 'GET', null);
    }

    const mainInformationForProfile = async (companyId) => {
        const url = `company/mainInformationForProfile/`+companyId
        return await request(url, 'GET', null);
    }

    const commonInformation = async () => {
        const url = `company/commonInformation`
        return await requestWithToken(url, 'GET', null);
    }

    const addInFavoriteProfiles = async(data) => {
        const url = `company/addInFavoriteProfiles`
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }

    const createCompany = async(data) => {
        const url = `company/createCompany`
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }

    const uploadImages = async(imageType, data) => {
        const url = `company/uploadImages/`+imageType;
        return await requestWithToken(url, 'POST', data, {});
    }

    const addDescriptionAndFilesCompany = async (data) => {
        const url = `company/addDescriptionAndFilesCompany`
        return await requestWithToken(url, 'PUT', JSON.stringify(data));
    }

    const updateCompanyAddress = async(data) => {
        const url = `company/updateCompanyAddress`
        return await requestWithToken(url, 'PUT', JSON.stringify(data));
    }

    const updateCompanyInformation = async(data) => {
        const url = `company/updateCompanyInformation`
        return await requestWithToken(url, 'PUT', JSON.stringify(data));
    }

    const deleteFromFavoriteProfiles = async(data) => {
        const url = `company/deleteInFavoriteProfiles`
        return await requestWithToken(url, 'DELETE', JSON.stringify(data));
    }

    const deleteImages = async(data) => {
        const url = `company/deleteImages`
        return await requestWithToken(url, 'DELETE', JSON.stringify(data));
    }

    const reactToCompany = async(data) => {
        const url = `company/reactToCompany`
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }

    // Confirm

    const sendConfirmLink = async() => {
        const url = `confirmation/send/confirmLink`
        return await requestWithToken(url, 'POST', null);
    }

    const confirmLink = async(link) => {
        const url = `confirmation/confirmLink`
        return await request(url, 'POST', JSON.stringify(link));
    }

    // Event

    const createEvent = async(data) => {
        const url = `event/createEvent`
        return await requestWithToken(url, 'POST', data, {});
    }

    const getEventById = async (eventId) => {
        const url = `event/getEventById?eventId=` + eventId;
        return await requestWithToken(url, 'GET', null);
    }

    const eventList = async() => {
        const url = `event/list`
        return await requestWithToken(url, 'GET', null);
    }

    // File

    const getImage = async (type, fileId) => {
        const url = 'file/image/'+type+'/'+fileId;
        return await requestImage(url);
    }

    const getCompanyImage = async (fileId) => {
        const url = 'file/image/company/'+fileId
        return await requestImage(url);
    }

    const getAvatar = async (fileId) => {
        const url = 'file/image/avatar/'+fileId
        return await requestImage(url);
    }

    const getEventImage = async (fileId) => {
        const url = 'file/image/event/'+fileId
        return await requestImage(url);
    }

    const getPdf = async (storageFileId) => {
        const url = 'file/pdf/get/' + storageFileId
        return await requestPdf(url);
    }

    // FilterInformation

    const getAllCities = async () => {
        const url = `filter/getAllCities`
        return await requestWithToken(url, 'GET', null);
    }

    const getAllInstitutions = async () => {
        const url = `filter/getAllInstitutions`
        return await requestWithToken(url, 'GET', null);
    }

    const getAllSpecialityNames = async () => {
        const url = `filter/getAllSpecialityNames`
        return await requestWithToken(url, 'GET', null);
    }

    const getAllSpecialityNumbers = async () => {
        const url = `filter/getAllSpecialityNumbers`
        return await requestWithToken(url, 'GET', null);
    }

    const getAllVacancyCities = async () => {
        const url = `filter/vacancy/getAllCities`
        return await requestWithToken(url, 'GET', null);
    }

    const getAllVacancyRegions = async () => {
        const url = `filter/vacancy/getAllRegions`
        return await requestWithToken(url, 'GET', null);
    }

    // LoginCode

    const createLoginCode = async(data) => {
        const url = `loginCode/create`
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }

    // Manager

    const getManagerInformation = async () => {
        const url = `manager/mainInformation`
        return await requestWithToken(url, 'GET', null);
    }

    const reactToProfile = async(data) => {
        const url = `manager/reactToProfile`
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }

    const addInformationManager = async(data) => {
        const url = `manager/addInformationYourself`
        return await requestWithToken(url, 'PUT', JSON.stringify(data));
    }

    const updateInformationManager = async(data) => {
        const url = `manager/updateInformationManager`
        return await requestWithToken(url, 'PUT', JSON.stringify(data));
    }

    // Message

    const getDialog = async (data) => {
        const url = `message/getDialog`
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }

    const getUserDialogs = async () => {
        const url = `message/getUserDialogs`
        return await requestWithToken(url, 'GET', null);
    }

    const getMessagesFromDialog = async (dialogId) => {
        const url = `message/getMessagesFromDialog/`+dialogId
        return await requestWithToken(url, 'GET', null);
    }

    const sendMessage = async(data) => {
        const url = `message/sendMessage`
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }

    const readWholeDialog = async(data) => {
        const url = `message/readWholeDialog`
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }
    
    // Profile

    const profileMainInformation = async () => {
        const url = `profile/mainInformation`
        return await requestWithToken(url, 'GET', null);
    }

    const profileAllInformationForAdmin = async (profileId) => {
        const url = `profile/getAllInformation/`+profileId
        return await requestWithToken(url, 'GET', null);
    }

    const profileMainInformationForManager = async (profileId) => {
        const url = `profile/mainInformationForManager/`+profileId
        return await requestWithToken(url, 'GET', null);
    }

    const profileCommonInformation = async () => {
        const url = `profile/commonInformation`
        return await requestWithToken(url, 'GET', null);
    }

    const educationInformation = async () => {
        const url = `profile/educationInformation`
        return await requestWithToken(url, 'GET', null);
    }

    const aboutMeInformation = async () => {
        const url = `profile/aboutMeInformation`
        return await requestWithToken(url, 'GET', null);
    }

    const getCertificates = async () => {
        const url = `profile/certificates`
        return await requestWithToken(url, 'GET', null);
    }

    const listCandidates = async(data) => {
        const url = `profile/list`
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }

    const uploadAvatar = async(data) => {
        const url = `profile/uploadAvatar`;
        return await requestWithToken(url, 'POST', data, {});
    }

    const uploadCertificates = async(data) => {
        const url = `profile/uploadCertificates`;
        return await requestWithToken(url, 'POST', data, {});
    }

    const addInformationYourself = async(data) => {
        const url = `profile/addInformationYourself`
        return await requestWithToken(url, 'PUT', JSON.stringify(data));
    }

    const addEducation = async(data) => {
        const url = `profile/addEducation`
        return await requestWithToken(url, 'PUT', JSON.stringify(data));
    }

    const addSkills = async(data) => {
        const url = `profile/addSkills`
        return await requestWithToken(url, 'PUT', JSON.stringify(data));
    }

    const updateProfileCommonInformation = async(data) => {
        const url = `profile/updateCommonInformation`
        return await requestWithToken(url, 'PUT', JSON.stringify(data));
    }

    const deleteCertificates = async(data) => {
        const url = `profile/deleteCertificates`
        return await requestWithToken(url, 'DELETE', JSON.stringify(data));
    }

    // Reaction

    const getReactionById = async (reactionId) => {
        const url = `reaction/getReactionById/`+reactionId
        return await requestWithToken(url, 'GET', null);
    }

    const getReactionsByVacancy = async(vacancyId, data) => {
        const url = `reaction/getReactionsByVacancy/`+vacancyId
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }

    const getReactionsByProfile = async (data) => {
        const url = `reaction/getReactionsByProfile`
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }

    const reactToVacancy = async(data) => {
        const url = `reaction/reactToVacancy`
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }

    const resolveToReaction = async(data) => {
        const url = `reaction/resolveToReaction`
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }
    
    const updateReactionStatusByProfile = async(data) => {
        const url = `reaction/updateReactionStatusByProfile`
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }
    
    const checkExistenceReaction = async(data) => {
        const url = `reaction/checkExistenceReaction`
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }
    
    const getContactsByReactionId = async (reactionId) => {
        const url = `reaction/getContactsByReactionId/`+reactionId
        return await requestWithToken(url, 'GET', null);
    }

    // RegistrationLinks
    
    const createRegistrationLink = async(data) => {
        const url = `registrationLinks/create`
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }

    const listRegistrationLinks = async(data) => {
        const url = `registrationLinks/list`
        return await requestWithToken(url, 'GET', JSON.stringify(data));
    }

    // ResetPasswordLinks
    
    const createResetPasswordLinks = async(data) => {
        const url = `ResetPasswordLinks/create`
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }

    // Vacancy

    const getVacancyById = async (vacancyId) => {
        const url = `vacancy/getVacancyById?vacancyId=`+vacancyId
        return await requestWithToken(url, 'GET', null);
    }
    
    const listVacancyLightWeightByCompany = async () => {
        const url = `vacancy/listVacancyLightWeightByCompany`
        return await requestWithToken(url, 'GET', null);
    }

    const listVacancies = async (data) => {
        const url = `vacancy/list`
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }

    const listVacancyByCompany = async (data) => {
        const url = `vacancy/listVacancyByCompany`
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }

    const createVacancy = async(data) => {
        const url = `vacancy/createVacancy`
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }

    const updateVacancy = async(data) => {
        const url = `vacancy/updateVacancy`
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }

    const changeStatusVacancy = async(data) => {
        const url = `vacancy/changeStatusVacancy`
        return await requestWithToken(url, 'POST', JSON.stringify(data));
    }

    const deleteVacancy = async(data) => {
        const url = `vacancy/deleteVacancy`
        return await requestWithToken(url, 'DELETE', JSON.stringify(data));
    }

    return {error,
        clearError, 
        login,
        loginWithCode,
        registerManager,
        registerStudent,
        resetPassword,

        mainInformation,
        mainInformationForProfile,
        commonInformation,
        addInFavoriteProfiles,
        createCompany,
        uploadImages,
        addDescriptionAndFilesCompany,
        updateCompanyAddress,
        updateCompanyInformation,
        deleteFromFavoriteProfiles,
        deleteImages,
        reactToCompany,

        sendConfirmLink,
        confirmLink,

        createEvent,
        getEventById,
        eventList,

        getImage,
        getCompanyImage,
        getAvatar,
        getEventImage,
        getPdf,

        getAllCities,
        getAllInstitutions,
        getAllSpecialityNames,
        getAllSpecialityNumbers,
        getAllVacancyCities,
        getAllVacancyRegions,

        createLoginCode,

        getManagerInformation,
        reactToProfile,
        addInformationManager,
        updateInformationManager,

        getDialog,
        getUserDialogs,
        getMessagesFromDialog,
        sendMessage,
        readWholeDialog,

        profileMainInformation,
        profileAllInformationForAdmin,
        profileMainInformationForManager,
        profileCommonInformation,
        educationInformation,
        aboutMeInformation,
        getCertificates,
        listCandidates,
        uploadAvatar,
        uploadCertificates,
        addInformationYourself,
        addEducation,
        addSkills,
        updateProfileCommonInformation,
        deleteCertificates,
        
        getReactionById,
        getReactionsByVacancy,
        getReactionsByProfile,
        reactToVacancy,
        resolveToReaction,
        updateReactionStatusByProfile,
        checkExistenceReaction,
        getContactsByReactionId,

        createRegistrationLink,
        listRegistrationLinks,

        createResetPasswordLinks,

        getVacancyById,
        listVacancyLightWeightByCompany,
        listVacancies,
        listVacancyByCompany,
        createVacancy,
        updateVacancy,
        changeStatusVacancy,
        deleteVacancy,
    }
}

export default usePortalService;